import React, {useState, useContext, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {AppContext} from '../../../context/context'
import {DidYouMeanContainer} from './styles'
import {sanitizeAndDecode} from '../../../utils/utils'

// Uses the ElasticSearch Phrase Suggester via curl to the API
const DidYouMean = () => {
  const {t} = useTranslation('common')
  const {state} = useContext(AppContext)
  const [didYouMean, setDidYouMean] = useState()

  // Using the `Fetch API`, we create the headers and body for the phrase suggester request.
  const requestHeaders = new Headers()
  requestHeaders.append(
    'Authorization',
    `ApiKey ${process.env.REACT_APP_DID_YOU_MEAN_KEY}`,
  )
  requestHeaders.append('Content-Type', 'application/json')

  // View Phrase Suggester docs for information on the fields below:
  // https://www.elastic.co/guide/en/elasticsearch/reference/7.17/search-suggesters.html#phrase-suggester
  const requestBody = JSON.stringify({
    suggest: {
      text: state.query,
      simple_phrase: {
        phrase: {
          field: 'title',
          size: 5,
          gram_size: 3,
          max_errors: 2,
          shard_size: 3,
          confidence: 2,
          collate: {
            query: {
              source: {
                bool: {
                  must: [
                    {
                      multi_match: {
                        query: '{{suggestion}}',
                        fields: ['title^2', 'body', 'drupal_metadata'],
                      },
                    },
                    {
                      match: {
                        lang: state.language,
                      },
                    },
                  ],
                },
              },
            },
            prune: true,
          },
        },
      },
    },
  })

  // The request is POST, as it has a body attached but is only doing a search to the` _search` endpoint
  const requestOptions = {
    method: 'POST',
    headers: requestHeaders,
    body: requestBody,
    redirect: 'follow',
  }

  // Asynchronous to the results, letting the results and this API request fetch at the same time.
  async function fetchDidYouMean() {
    try {
      // Run the request with the options
      const didYouMeanResponse = await fetch(
        `${process.env.REACT_APP_DID_YOU_MEAN_API_URL}`,
        requestOptions,
      )
        .then(response => response.json())
        .then(result => result?.suggest?.simple_phrase[0]?.options)

      // If the results have a document matching a result in the index.
      if (didYouMeanResponse[0]?.collate_match) {
        setDidYouMean(didYouMeanResponse ? didYouMeanResponse[0]?.text : '')
      }
      return ''
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    // Do the fetch request when the query changes
    fetchDidYouMean()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.query])

  function handleClick(dymResponse, e) {
    e.preventDefault()

    // capture GA
    window.dataLayer ||= []
    window.dataLayer.push({
      event: 'view_search_results',
      search_term: sanitizeAndDecode(dymResponse).toLowerCase(), //auto-correct from dym
      search_type: 'did you mean',
      suggested_search_prompt: sanitizeAndDecode(state.query), //original (misspelled) query
    })

    window.location.href = e.target.href
  }

  return (
    <DidYouMeanContainer>
      {didYouMean ? (
        <span className="inline-dym">{t('didYouMean')}: </span>
      ) : (
        ''
      )}
      <a
        className="bolded-suggestion"
        href={`${process.env.REACT_APP_URL}${t(
          'header.searchPath',
        )}?query=${didYouMean}`}
        onClick={e => handleClick(didYouMean, e)}
      >
        {didYouMean}
      </a>
    </DidYouMeanContainer>
  )
}
export default DidYouMean
